import { render } from "./RegisterPage.vue?vue&type=template&id=75303acb&scoped=true"
import script from "./RegisterPage.vue?vue&type=script&lang=js"
export * from "./RegisterPage.vue?vue&type=script&lang=js"

import "./RegisterPage.vue?vue&type=style&index=0&id=75303acb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75303acb"]])

export default __exports__